import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=4c836740&scoped=true&"
var script = {}
import style0 from "./Purchases.vue?vue&type=style&index=0&id=4c836740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c836740",
  null
  
)

export default component.exports